import { useState } from 'react';

export const useLocal = <T>(initialValueCreator: () => T): T =>
  useState<T>(initialValueCreator)[0];
